module.exports = __webpack_public_path__ + "img/sellcard-preLogin.64ce8624.png";